var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 848,
    height: 915,
    viewBox: "0 0 848 915",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2626_10442)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2626_10442)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 299.946,
    cy: 271.946,
    r: 153.946,
    fill: "#F2059F"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2626_10442)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 431.367,
    cy: 485.715,
    rx: 131.422,
    ry: 185.536,
    fill: "#712CE1"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2626_10442",
    x: -103,
    y: -131,
    width: 805.892,
    height: 805.892,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 124.5,
    result: "effect1_foregroundBlur_2626_10442"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2626_10442",
    x: 50.9453,
    y: 51.1787,
    width: 760.844,
    height: 869.073,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 124.5,
    result: "effect1_foregroundBlur_2626_10442"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2626_10442"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 848,
    height: 915,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradient);
export default __webpack_public_path__ + "static/media/gradient.e5991b158e64c763335cd2afea913cab.svg";
export { ForwardRef as ReactComponent };